<template>
    <div class="sales-card-actions" >
        <div class="sales-card-actions-inner" v-if="!isMobileChecker">
            <div class="action-btn-prev slider-btn">
                <svgIcon name="left-arrow" class="icon-left-arrow"/>
            </div>
            <div class="actions-carousel">
                <swiper :options="swiperOption" ref="salesCardActionsCarousel">
                    <swiper-slide v-for="(slide, index) in salesCardArr.project_page_in.important_cards" :key="index">
                        <a href="#" @click.prevent="openContactsFormModal('call-page-get', cardID, slide.title)">
                            <div class="slide-info">
                                <strong>{{ slide.title }}</strong>
                            </div>
                            <div class="btn-consult">
                                <span>{{salesCardArr.project_page_in.setup_consult_btn}}</span>
                                <svgIcon name="right-arrow" class="icon-right-arrow"/>
                            </div>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="action-btn-next slider-btn">
                <svgIcon name="right-arrow" class="icon-right-arrow"/>
            </div>
        </div>
        <div class="mobile-container" v-if="isMobileChecker">
            <div class="item" v-for="(item, index) in salesCardArr.project_page_in.important_cards">
                <strong>{{ item.title }}</strong>
                <div class="btn-consult" @click="openContactsFormModal('call-page-get', cardID, item.title)">
                    <span>{{salesCardArr.project_page_in.setup_consult_btn}}</span>
                    <svgIcon name="right-arrow" class="icon-right-arrow"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-actions',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                dataArr: null,
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 3,
                    spaceBetween: 25,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3000,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.action-btn-next',
                        prevEl: '.action-btn-prev',
                    },
                    breakpoints: {
                        // when window width is <= 900px
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                    }
                    // pagination: {
                    //     el: '.promo-pagination',
                    //     type: 'bullets',
                    //     clickable: true,
                    // },
                },
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-important.scss';
    @import '@/styles/components/sales-card/respond/sales-card-important-respond.scss';
</style>